var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("span", [_vm._v(_vm._s(_vm.attributeData.displayName))]),
      _c("MediaFilePicker", {
        attrs: { label: "", multiple: false, value: _vm.value },
        on: {
          change: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
      }),
      _c("ErrorMessage", { attrs: { message: _vm.errorMessage } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }